// eslint-disable-next-line import/no-cycle
import { queryUserGroup, queryUser, queryDepartments } from '@/api/admin';

const cache = {
  state: {
    allUsers: [], // 缓存所有users
    allGroups: [], // 缓存所有分组
    allDepartments: [], // 缓存所有人事组
  },

  mutations: {
    SET_CACHE_USERS: (state, users) => {
      state.allUsers = users;
    },
    SET_CACHE_GROUPS: (state, groups) => {
      state.allGroups = groups;
    },
    SET_CACHE_DEPARTMENTS: (state, departments) => {
      state.allDepartments = departments;
    },
  },

  actions: {
    // 获取所有用户，传入参数获取最新记录
    getAllUsers({ commit, state }, latest) {
      return new Promise((resolve, reject) => {
        if (state.allUsers.length > 0 && !latest) {
          resolve(state.allUsers);
        } else {
          queryUser({ page: 1, per_page: 10000 })
            .then((response) => {
              const { data } = response;
              commit('SET_CACHE_USERS', data.users);
              resolve(data.users);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },

    // 获取所有分组，传入参数获取最新记录
    getAllGroups({ commit, state }, latest) {
      return new Promise((resolve, reject) => {
        if (state.allGroups.length > 0 && !latest) {
          resolve(state.allGroups);
        } else {
          queryUserGroup({ page: 1, per_page: 10000 })
            .then((response) => {
              const { data } = response;
              commit('SET_CACHE_GROUPS', data.groups);
              resolve(data.groups);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    // 获取所有分组，传入参数获取最新记录
    getAllDepartments({ commit, state }, latest) {
      return new Promise((resolve, reject) => {
        if (state.allGroups.length > 0 && !latest) {
          resolve(state.allGroups);
        } else {
          queryDepartments({ page: 1, per_page: 10000 })
            .then((response) => {
              const { data } = response;
              commit('SET_CACHE_DEPARTMENTS', data);
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
  },
};

export default cache;
